import { render, staticRenderFns } from "./VirtualPager.vue?vue&type=template&id=38d75f26"
import script from "./VirtualPager.vue?vue&type=script&lang=js"
export * from "./VirtualPager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports